/* eslint-disable indent */
import { SDKORDERID } from '../actions/orderActions';

const initialAuthState = {
  orderIdFromSdk: '',
};

const orderIdReducer = (state = initialAuthState, action) => {
  switch (action.type) {
    case SDKORDERID:
      return {
        ...state,
        orderIdFromSdk: action.payload,
      };
    default:
      return state;
  }
};

export default orderIdReducer;
